/**
 * Gradebook Admin JS
 */

import * as lpUtils from './utils.js';
import { submitFilter, dateChoiceFilterHandler } from "./gradebook-admin-share.js";
import * as studentDetail from './admin/student-detail.js';

const filter = ( e, target ) => {
	if ( ! target.closest( '.lp-btn-filter-gradebook' ) ) {
		return;
	}

	const elFilterAction = target.closest( '.filter-actions' );
	const elWrapClass = elFilterAction.dataset.element;
	const elWrap = document.querySelector( `${ elWrapClass }` );
	const elLPTarget = elWrap.querySelector( '.lp-target' );

	const form = target.closest('.lp-form-gradebook-filter');
	lpUtils.lpSetLoadingEl( target, 1 );

	const callBack = {
		success: ( response ) => {
			const { message, status, data } = response;

			if ( status === 'success' ) {
				elLPTarget.innerHTML = data.content;
			} else {
				console.error( message );
			}
		},
		error: ( error ) => {
			console.log( error );
		},
		completed: () => {
			lpUtils.lpSetLoadingEl( target, 0 );
		},
	};

	submitFilter( form, callBack );
};

const reset = ( e, target ) => {
	if ( ! target.closest( '.lp-btn-reset-gradebook' ) ) {
		return;
	}

	const form = target.closest('.lp-form-gradebook-filter');
	lpUtils.lpSetLoadingEl( target, 1 );

	form.reset();
	form.querySelectorAll('.tomselected').forEach( ( tomselectedElement ) => {
		tomselectedElement.tomselect.clear();
	});

	const elFilterAction = target.closest( '.filter-actions' );
	const elWrapClass = elFilterAction.dataset.element;
	const elWrap = document.querySelector( `${ elWrapClass }` );
	const elLPTarget = elWrap.querySelector( '.lp-target' );

	const callBack = {
		success: ( response ) => {
			const { message, status, data } = response;
			elLPTarget.innerHTML = data.content;
		},
		error: ( error ) => {
			console.log( error );
		},
		completed: () => {
			lpUtils.lpSetLoadingEl( target, 0 );
		},
	};

	submitFilter( form, callBack );
};

document.addEventListener( 'click', ( e ) => {
	let target = e.target;
	filter( e, target );
	reset( e, target );
} );

document.addEventListener( 'change', ( e ) => {
	let target = e.target;
	dateChoiceFilterHandler( e, target );
} );

